var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-calendar"},[_c('p',{staticClass:"date",class:{ 'date__deactivated': _vm.disabled}},[_vm._v(" "+_vm._s(_vm.dateToShow)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }